// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.X04sQO2xKDCICM {
  position: relative;
}
.X04sQO2xKDCICM .XzfyLbeV1WcKC5 {
  margin-bottom: var(--ds-space-300, 24px);
}
.X04sQO2xKDCICM tbody {
  background-color: transparent;
}
.X04sQO2xKDCICM .x1m4ntsSNNk8Di {
  position: absolute;
  right: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
}
@media only screen and (max-width: 600px) {
  .X04sQO2xKDCICM .x1m4ntsSNNk8Di {
    position: relative;
    margin-top: var(--ds-space-100, 8px);
  }
}
`, ""]);
// Exports
export var paymentModal = `X04sQO2xKDCICM`;
export var description = `XzfyLbeV1WcKC5`;
export var backToPlansButton = `x1m4ntsSNNk8Di`;
export default ___CSS_LOADER_EXPORT___;
